export default __webpack_public_path__ + "static/event_semantics-a9eeb7f774fb51d70f04be1a3e24a6dd.svg";